import { loadMarketSymbols, loadMarketKlines } from './market_proxy_client';
import { createExchangeWs } from './exchange_ws_base';

export default {
    symbols: [],

    async loadExchangeInfo() {
        this.symbols = await loadMarketSymbols('coinbase');
        return this.symbols;
    },
    async loadKline(symbol, tf, endTime) {
        return loadMarketKlines('coinbase', symbol, tf, endTime);
    },

    ...createExchangeWs({
        wsUrl: 'wss://ws-feed.exchange.coinbase.com',
        buildSubscribe: symbols => JSON.stringify({ type: 'subscribe', channels: [{ name: 'ticker', product_ids: symbols }] }),
        buildUnsubscribe: symbols => JSON.stringify({ type: 'unsubscribe', channels: [{ name: 'ticker', product_ids: symbols }] }),
    }),
};
